import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses, StoreHelpers } from "@green24/npm-javascript-utils";
import ButtonsConstructor from "./Input/Button/ButtonsConstructor";
import Interpret from "./Localization/Interpret";
import { ErrorUtils } from "../../utils/ErrorUtils";
import Fa from "./Fa";
import { ComponentUtils } from "@green24/npm-preact-utils";

class ErrorBlock extends Component {
	render({className, style, error, errorOverrides, onRetry, suffix, actionButtons}) {
		const data = StoreHelpers.deepMerge(this._processError(error), errorOverrides[error.statusCode], true);
		const retryButton = {
			icon: "sync-alt",
			text: "retry",
			elevation: 1,
			action: () => onRetry(),
		};
		const defaultButtons = [
			data.retry && onRetry && retryButton,
		]

		return (
			<section className={combineClasses("error-block", className)} style={style}>
				<Fa icon={data.icon || "exclamation-triangle"}/>

				<h1><Interpret id={data.title}/></h1>

				<p>{data.message}</p>

				<ButtonsConstructor buttons={ComponentUtils.resolvePolymorphProp(
					actionButtons,
					{
						array: arr => [...defaultButtons, ...arr],
						function: f => f({data, defaultButtons, retryButton}),
					},
					() => defaultButtons,
				)}/>

				{suffix}
			</section>
		);
	}

	_processError(error) {
		return ErrorUtils.getErrorFromResponse(error);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			/**
			 * @type HttpResponseError
			 */
			error: PropTypes.object.isRequired,
			errorOverrides: PropTypes.object,
			onRetry: PropTypes.func,
			actionButtons: PropTypes.any,
		}
	}

	static get defaultProps() {
		return {
			errorOverrides: {},
			onRetry: null,
		}
	}
}

export default ErrorBlock;
